import { FC, useCallback, useEffect, useRef } from 'react';
import { useTranslation} from 'react-i18next';
import { isDesktop } from "react-device-detect";
import { useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { Tooltip } from 'antd';
import cn from 'classnames';

import { getSelectedGameBoxTag } from '../../store/selectors';
import { TITLE_ICONS } from '../../utils/constants';

import './styles.scss';

interface MissionInfoProps {
    mission?: any;
    tag?: string;
    setIsOpen?: (st?: boolean) => void;
    isOpen?: boolean;
    storedRaceValue?: string | null;
}

const MissionTitleAndDescriptionWidget: FC<MissionInfoProps> = ({ mission, tag, isOpen, setIsOpen, storedRaceValue }) => {
    const { t } = useTranslation();
    const selectedGameBoxTag = useSelector(getSelectedGameBoxTag);
    const classes = cn('title-and-description-widget-wrapper');
    const tooltipRef = useRef<HTMLDivElement>(null);

    const getShortDescription = (raceId: string | null | undefined) => {
        if (!mission) return null;
        if (mission.length > 1 && selectedGameBoxTag === 'race') {
            const raceData = mission.find((data: { id: number }) => data.id === Number(raceId));
            return raceData?.short_description || raceData?.description;
        }
        return mission.short_description || mission.description;
    };
    
    const handleClickOutside = useCallback((event: MouseEvent) => {
        if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
            setIsOpen && setIsOpen(false);
        }
    }, [setIsOpen]);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClickOutside]);

    const openTooltip = () => {
        setIsOpen && setIsOpen(!isOpen);
    }

    return (
        (tag || selectedGameBoxTag) && (
            <div className="game-box-widget__content--title-and-description">
                <div className={classes}>
                    <div className="title-and-description-widget-wrapper__title">
            <span>
              <>
                <img
                    src={`/static/images/${TITLE_ICONS[tag ?? selectedGameBoxTag]}/${
                        TITLE_ICONS[tag ?? selectedGameBoxTag]
                    }.png`}
                    alt={tag ?? selectedGameBoxTag}
                    className="title-and-description-widget-wrapper__title--img"
                />
                <img
                    src={`/static/images/line.svg`}
                    alt="line"
                    className="title-and-description-widget-wrapper__title--line"
                />
                <span className="title-and-description-widget-wrapper__title-text">
                  {tag
                      ? t(`gameBoxCategories.${tag}`)
                      : t(`gameBoxMissionTitleAndDescription.${selectedGameBoxTag}.title`)}
                </span>
              </>
            </span>
                {TITLE_ICONS[tag ?? selectedGameBoxTag] !== 'miniGames' && (
                    <div ref={tooltipRef}>
                        <Tooltip
                            title={getShortDescription(storedRaceValue)}
                            trigger={'click'}
                            color={'#131429'}
                            arrow={false}
                            placement="left"
                            open={isOpen}
                            overlayClassName={isDesktop ? 'title-tooltip' : 'title-tooltip__mobile'}
                            onOpenChange={()=> openTooltip()}
                         >
                            <ReactSVG src="/static/images/info.svg" />
                         </Tooltip>
                     </div>
                )}
                    </div>
                </div>
            </div>
        )
    );
};

export default MissionTitleAndDescriptionWidget;
